<script>
    export default {
        name: 'NormalCheckBox',
        props: {
            // 是否选中
            checked: {
                default: false,
                required: false
            },
            // 是否禁用
            disabled: {
                type: Boolean,
                default: false,
                required: false
            }
        },
        data () {
            return {
                selfChecked: this.checked
            };
        },
        model: {
            prop: 'checked',
            event: 'check'
        },
        watch: {
            checked (v) {
                this.selfChecked = v;
            }
        },
        computed: {
            isChecked: {
                get () {
                    return this.selfChecked;
                },
                set (val) {
                    this.selfChecked = val;
                    this.$emit('check', val);
                }
            }
        }
    };
</script>
<template>
    <div class="normal-checkbox" :class="{
        disabled: disabled
    }">
        <input type="checkbox"
               v-model="isChecked"
               :disabled="disabled"
               class="normal-check"
        >
        <i class="normal-check-icon"></i>
    </div>
</template>
<style scoped lang="less">
    @import "../../assets/less/widgets-var";

    .normal-checkbox {
        font-size: 0;
        .px2rem(height, 90);
        .px2rem(line-height, 92);

        &.disabled {
            .normal-check-icon:before {
                background-color: @otherDisabledBgClr;
            }
        }
    }


    .normal-check {
        position: absolute;
        left: -99999rem;

        &:checked + .normal-check-icon:before {
            content: '\E695';
            background-color: @primaryBg;
            color: @whiteBg;
            border: none;
        }
    }

    .normal-check-icon {
        box-sizing: border-box;
        display: inline-block;
        vertical-align: middle;
        font: normal normal normal 14px/1 "cmsicon";
        font-size: inherit;
        text-rendering: auto;
        .px2rem(width, 38);
        .px2rem(height, 38);

        &:before {
            box-sizing: border-box;
            content: '';
            display: block;
            border: 1px solid @otherBtnBorderNoteClr;
            .px2rem(border-radius, 10);
            text-align: center;
            .px2rem(width, 38);
            .px2rem(font-size, 26);
            .px2rem(height, 38);
            .px2rem(line-height, 42);

        }
    }
</style>
